module.exports = __webpack_public_path__ + "img/9788901058382.4ad706c3.jpg";